"use client";

import Link from "next/link";
import { AlertTriangle } from "lucide-react";
import { useEffect } from "react";

import { Button } from "@/components/ui/button";
import { isApiError } from "@/lib/api/errors";

export default function ErrorPage({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  const network = isApiError(error) && error.kind === "network";
  return (
    <div className="container-page flex min-h-[60vh] items-center justify-center py-20">
      <div className="glass w-full max-w-lg rounded-3xl p-10 text-center">
        <div className="mx-auto mb-6 flex size-16 items-center justify-center rounded-2xl bg-danger/15 text-danger">
          <AlertTriangle className="size-8" />
        </div>
        <h1 className="text-3xl font-bold">{network ? "Store temporarily unavailable" : "Something went wrong"}</h1>
        <p className="mt-3 text-text-secondary">
          {network ? "We could not reach the store services. Please try again in a moment." : "Something went wrong on our end. Please try again later."}
        </p>
        {error.digest && <p className="mt-2 font-mono text-xs text-text-muted">Reference: {error.digest}</p>}
        <div className="mt-8 flex justify-center gap-3">
          <Button variant="outline" className="rounded-xl" onClick={reset}>
            Try again
          </Button>
          <Button asChild className="rounded-xl">
            <Link href="/">Back to home</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
